import { createFileRoute } from "@tanstack/react-router";
import BordeauxPage, {
  BORDEAUX_DESCRIPTION,
  BORDEAUX_PATH,
  BORDEAUX_SCHEMA,
  BORDEAUX_TITLE,
} from "@/pages/BordeauxPage";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/fractional-cmo-bordeaux")({
  head: () => ({
    ...pageHead({ path: BORDEAUX_PATH, title: BORDEAUX_TITLE, description: BORDEAUX_DESCRIPTION }),
    scripts: BORDEAUX_SCHEMA.map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
  }),
  component: BordeauxPage,
});
